import List from '@mui/material/List'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import * as React from 'react'
import { useEffect } from 'react'
import { DateInfoItem } from '../../../../components/DateInfoItem/DateInfoItem'
import { ProjectDeleteDialog } from '../../../../dialogs/ProjectDeleteDialog/ProjectDeleteDialog'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import { ProjectItemMenu } from '../../ProjectPage/components/ProjectItemMenu'

export const ProjectArchiveList = () => {
    const [openRemoveDialog, setOpenRemoveDialog] = React.useState<boolean>(false)
    const [activeId, setActiveId] = React.useState<boolean>(null)

    const { fetchWorkplace, workplaceArchived } = useAssistantAdministrationStore((state) => state)
    useEffect(() => {
        fetchWorkplace({ limit: 100, is_archived: true })
    }, [])

    const handleClickOpenRemoveDialog = (id) => {
        setActiveId(id)
        setOpenRemoveDialog(true)
    }

    const handleClose = () => {
        setActiveId(null)
        setOpenRemoveDialog(false)
    }

    return (
        <div>
            {workplaceArchived?.length > 0 && (
                <List
                    sx={{
                        overflowY: 'auto',
                        minHeight: '280px',
                        px: 2,
                        height: 'calc(100dvh - 200px)',
                    }}>
                    {map(workplaceArchived, (item) => {
                        const { title, id, archived_at } = item
                        return (
                            <Stack
                                key={id}
                                direction="row"
                                sx={{
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    '&:hover': { background: 'rgba(0, 0, 0, 0.04)' },
                                    '&:hover #buttons': {
                                        visibility: 'visible',
                                    },
                                    '& #buttons': { visibility: 'hidden' },
                                    mb: 2,
                                }}>
                                <Stack
                                    direction="column"
                                    sx={{ cursor: 'pointer', width: '100%' }}
                                    onClick={() =>
                                        window.open(
                                            `/project?workplaceId=${id}&is_archived=true`,
                                            '_self',
                                        )
                                    }>
                                    <Stack direction="row">
                                        <ListItemText primary={title} sx={{ textAlign: 'left' }} />
                                    </Stack>
                                    {archived_at && (
                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            sx={{
                                                pl: '30px',
                                                borderRadius: '24px',
                                                alignItems: 'center',
                                                my: '12px',
                                            }}>
                                            <Typography variant="caption1">
                                                Архивировано:
                                            </Typography>
                                            <DateInfoItem date={archived_at} />
                                        </Stack>
                                    )}
                                </Stack>
                                <ProjectItemMenu workplaceDetail={{ is_archived: true, id }} />
                            </Stack>
                        )
                    })}
                </List>
            )}

            {workplaceArchived?.length < 1 && (
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        padding: '24px',
                        borderRadius: '24px',
                        alignItems: 'center',
                        my: '12px',
                    }}>
                    <Typography variant="caption1" mb={1}>
                        Архив пуст
                    </Typography>
                </Stack>
            )}

            {openRemoveDialog && activeId && (
                <ProjectDeleteDialog
                    open={openRemoveDialog}
                    handleClose={handleClose}
                    id={activeId}
                />
            )}
        </div>
    )
}
